export default __webpack_public_path__ + "static/media/Totem of the Eternal Winter.7ba6d4ba.jpg";